import UPDATE_AUTHENTIFICATION from './types';

export default {

  [UPDATE_AUTHENTIFICATION](state, boolean) {
    state.authorized = boolean;
  },

};



// WEBPACK FOOTER //
// ./src/store/drivers/mutations.js